<template>
  <SimpleCarousel
    data-testid="related-products-carousel"
    class="carousel"
    :slider-items="sliderItems"
    slide-class="carousel__item"
    :per-page="perPage"
    :height="'100%'"
    :fixed-slide-width-value="productCardWidth"
    :wrapper-classes="wrapperClasses"
    :gap="productSliderGap"
    :has-controls-outside-container="hasControlsOutsideContainer"
    :prev-arrow-class="prevArrowClass"
    :next-arrow-class="nextArrowClass"
    :arrows="hasArrows"
  >
    <template #default="{ currentItem }">
      <slot
        name="default"
        :current-item="currentItem"
      />
    </template>
  </SimpleCarousel>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';

import type { ProductCardSize } from '~~/constants/productCardSize';
import { PRODUCT_CARD_SIZE } from '~~/constants/productCardSize';

const PRODUCT_SLIDER_SIZE = {
  MINI: 'mini',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

export default defineComponent({
  name: 'ProductSlider',

  props: {
    sliderItems: {
      type: Array,
      default: () => [],
    },
    hasControlsOutsideContainer: {
      type: Boolean,
      default: false,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 4,
    },
    prevArrowClass: {
      type: String,
      default: 'left-0',
    },
    nextArrowClass: {
      type: String,
      default: 'right-0',
    },
    size: {
      type: String as PropType<ProductCardSize>,
      default: PRODUCT_CARD_SIZE.RESPONSIVE,
      validator: (value: ProductCardSize) => {

        return Object.values(PRODUCT_CARD_SIZE).includes(value);
      
      },
    },
    hasArrows: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const { isMobile } = useUiMode();
    const { isMounted } = useIsMounted();

    const wrapperClasses = computed(() => `mx-auto${props.isFullWidth ? '' : ' lg:max-w-relatedProducts'}`);
    const productCardSize = computed(() => {

      if (props.size === PRODUCT_CARD_SIZE.MINI) {

        return PRODUCT_SLIDER_SIZE.MINI;
      
      }

      if (props.size === PRODUCT_CARD_SIZE.MEDIUM || isMobile.value || !isMounted.value) {

        return PRODUCT_SLIDER_SIZE.MEDIUM;
      
      }

      return PRODUCT_SLIDER_SIZE.LARGE;
    
    });

    const productCardWidths = {
      [PRODUCT_SLIDER_SIZE.MINI]: 150,
      [PRODUCT_SLIDER_SIZE.MEDIUM]: 229,
      [PRODUCT_SLIDER_SIZE.LARGE]: 337,
    };
    const productCardWidth = computed(() => productCardWidths[productCardSize.value]);

    const productCardGaps = {
      [PRODUCT_SLIDER_SIZE.MINI]: 16,
      [PRODUCT_SLIDER_SIZE.MEDIUM]: 16,
      [PRODUCT_SLIDER_SIZE.LARGE]: 30,
    };
    const productSliderGap = computed(() => productCardGaps[productCardSize.value]);

    return {
      LINK_TYPE,
      wrapperClasses,
      PRODUCT_CARD_SIZE,
      productSliderGap,
      productCardWidth,
    };
  
  },
});


</script>
